import { Component } from '@mycolorway/tao';

Component('tr-todo-label-field', {

  ready() {
    this.sortSelectedResult();
    this.sortSelectedOptions();
  },

  sortSelectedResult() {
    const chipSet = this.querySelector('.mdc-chip-set');
    const chips = Array.prototype.slice.call(
      this.querySelectorAll('.mdc-chip-set > .mdc-chip'),
    ).sort((chipA, chipB) => {
      const chipAIndex = chipA.getAttribute('data-selected-index');
      const chipBIndex = chipB.getAttribute('data-selected-index');
      return parseInt(chipBIndex, 10) - parseInt(chipAIndex, 10);
    });

    chips.forEach(chip => chipSet.insertAdjacentElement('afterbegin', chip));
  },

  sortSelectedOptions() {
    const resultField = this.querySelector('.selector-field-result');
    const { selectedOptions } = resultField;

    if (selectedOptions && selectedOptions.length > 0) {
      resultField.selectedOptions = selectedOptions.sort((optionA, optionB) => {
        const optionAIndex = optionA.data['selected-index'];
        const optionBIndex = optionB.data['selected-index'];
        return parseInt(optionAIndex, 10) - parseInt(optionBIndex, 10);
      });
    }
  },
});
